import RPropTypes from 'prop-types';

export default {
  ...RPropTypes,
  children: RPropTypes.oneOfType([RPropTypes.node, RPropTypes.arrayOf(RPropTypes.node)]),
};
